var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { goBack, navigateTo, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { DelegationType } from '@popup/steem/pages/app-container/home/delegations/delegation-type.enum';
import { FavoriteUserUtils } from '@popup/steem/utils/favorite-user.utils';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import TokensUtils from '@popup/steem/utils/tokens.utils';
import { KeychainKeyTypes } from '@steempro/steem-keychain-commons';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { Separator } from 'src/common-ui/separator/separator.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import { Screen } from 'src/reference-data/screen.enum';
import FormatUtils from 'src/utils/format.utils';
const TokenIncomingOutgoing = ({ activeAccount, delegationType, username, amount, symbol, navigateToWithParams, navigateTo, setErrorMessage, setSuccessMessage, addToLoadingList, removeFromLoadingList, goBack, }) => {
    const [editModeActivated, setEditModeActivated] = useState(false);
    const [value, setValue] = useState('');
    const [isExpanded, setIsExpanded] = useState(false);
    const cancelDelegation = () => {
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('popup_html_confirm_cancel_delegation_message'),
            title: 'popup_html_cancel_delegation',
            fields: [{ label: 'popup_html_transfer_to', value: `@${username}` }],
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_cancel_delegation_operation', KeysUtils.getKeyType(activeAccount.keys.active, activeAccount.keys.activePubkey));
                try {
                    let tokenOperationResult = yield TokensUtils.cancelDelegationToken(username, symbol, amount.toString(), activeAccount.keys.active, activeAccount.name, options);
                    if (tokenOperationResult.broadcasted) {
                        addToLoadingList('html_popup_confirm_transaction_operation');
                        if (tokenOperationResult.confirmed) {
                            yield FavoriteUserUtils.saveFavoriteUser(username, activeAccount);
                            setSuccessMessage(`popup_html_cancel_delegation_tokens_success`);
                            navigateTo(Screen.HOME_PAGE, true);
                        }
                        else {
                            setErrorMessage('popup_token_timeout');
                        }
                    }
                    else {
                        setErrorMessage(`popup_html_cancel_delegation_tokens_failed`);
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList(`html_popup_cancel_delegation_operation`);
                    removeFromLoadingList('html_popup_confirm_transaction_operation');
                }
            }),
        });
    };
    const enterEditMode = () => {
        setEditModeActivated(true);
        setValue(amount);
    };
    const cancelEdit = () => {
        setEditModeActivated(false);
        setValue(amount);
    };
    const saveChanges = () => {
        setEditModeActivated(false);
        if (Number(value) <= 0) {
            cancelDelegation();
        }
        const formattedAmount = `${value} ${symbol}`;
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('popup_html_delegate_tokens_confirm_text'),
            title: 'popup_html_delegation',
            fields: [
                { label: 'popup_html_transfer_to', value: `@${username}` },
                { label: 'popup_html_value', value: formattedAmount },
            ],
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_delegation_operation');
                try {
                    let tokenOperationResult = yield TokensUtils.delegateToken(username, symbol, value.toString(), activeAccount.keys.active, activeAccount.name, options);
                    if (tokenOperationResult.broadcasted) {
                        addToLoadingList('html_popup_confirm_transaction_operation');
                        removeFromLoadingList(`html_popup_delegation_operation`);
                        removeFromLoadingList('html_popup_confirm_transaction_operation');
                        if (tokenOperationResult.confirmed) {
                            yield FavoriteUserUtils.saveFavoriteUser(username, activeAccount);
                            setSuccessMessage(`popup_html_delegate_tokens_success`);
                            navigateTo(Screen.HOME_PAGE, true);
                        }
                        else {
                            setErrorMessage('popup_token_timeout');
                        }
                    }
                    else {
                        setErrorMessage(`popup_html_delegate_tokens_failed`);
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList(`html_popup_delegation_operation`);
                    removeFromLoadingList('html_popup_confirm_transaction_operation');
                }
            }),
        });
    };
    const toggleExpandablePanel = () => {
        if (!editModeActivated)
            setIsExpanded(!isExpanded);
    };
    return (React.createElement("div", { className: "delegation-row", key: username }, username && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "item" },
            React.createElement("div", { className: "username" }, `@${username}`),
            React.createElement("div", { className: "item-details" },
                !editModeActivated && (React.createElement("div", { className: "value", onDoubleClick: () => {
                        if (delegationType === DelegationType.OUTGOING)
                            enterEditMode();
                    } },
                    FormatUtils.withCommas(amount),
                    " ",
                    symbol)),
                editModeActivated && (React.createElement("div", { className: "edit-panel" },
                    React.createElement("input", { className: "edit-label", value: value, onChange: (e) => setValue(e.target.value), placeholder: getMessage('popup_html_favorite_user_nickname') }),
                    React.createElement(SVGIcon, { onClick: () => saveChanges(), icon: SVGIcons.FAVORITE_ACCOUNTS_SAVE, className: "edit-button" }),
                    React.createElement(SVGIcon, { onClick: () => cancelEdit(), icon: SVGIcons.FAVORITE_ACCOUNTS_CANCEL, className: "edit-button" }))),
                delegationType !== DelegationType.INCOMING && (React.createElement(SVGIcon, { icon: SVGIcons.WALLET_HISTORY_EXPAND_COLLAPSE, className: `expand-collapse-icon ${isExpanded ? 'open' : 'closed'}`, onClick: toggleExpandablePanel })))),
        isExpanded && (React.createElement("div", { className: "expanded-panel" }, !editModeActivated && (React.createElement(React.Fragment, null,
            React.createElement(Separator, { type: "horizontal" }),
            React.createElement("div", { className: "expandable-panel-content" },
                React.createElement("div", { className: "delegation-item-button edit", onClick: () => enterEditMode() },
                    React.createElement(SVGIcon, { icon: SVGIcons.FAVORITE_ACCOUNTS_EDIT }),
                    React.createElement("span", { className: "label" }, getMessage('html_popup_button_edit_label'))),
                React.createElement("div", { className: "delegation-item-button delete", onClick: () => cancelDelegation() },
                    React.createElement(SVGIcon, { icon: SVGIcons.FAVORITE_ACCOUNTS_DELETE }),
                    React.createElement("span", { className: "label" }, getMessage('delete_label'))))))))))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    navigateToWithParams,
    navigateTo,
    setErrorMessage,
    setSuccessMessage,
    addToLoadingList,
    removeFromLoadingList,
    goBack,
});
export const TokenIncomingOutgoingItemComponent = connector(TokenIncomingOutgoing);
